export default "__VITE_ASSET__Bbm71XL0__"